var exports = {
  "_f": "BarrierComponents.module__barrierLayout___SENjY0",
  "Rt": "BarrierComponents.module__barrierLayoutNoAction___SENjY0",
  "Kk": "BarrierComponents.module__icon___SENjY0",
  "vV": "BarrierComponents.module__messageArea___SENjY0",
  "iU": "BarrierComponents.module__message___SENjY0",
  "C$": "BarrierComponents.module__actionArea___SENjY0",
  "O1": "BarrierComponents.module__timer___SENjY0",
};

module.exports = exports;
